import type { FounderCard } from '@doneverse/shared'
import { api } from '../api/index.js'

export const founderService = {
  /**
   * Founder-relationship cards for the signed-in doer — one per workspace they
   * belong to (name, photo, open-task count, last-message timestamp). Backs the
   * doer home page founder cards. User-scoped, not workspace-scoped.
   */
  fetchFounderCards: async (): Promise<{ founders: FounderCard[] }> => {
    return api.get('/v1/me/founders').json<{ founders: FounderCard[] }>()
  },
}
